// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"525":"bcf79393","776":"aa024b1c","874":"d2f5f10f"}[chunkId] + ".chunk.css";
};